
class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.detail = this.querySelector('details');
    this.summary = this.detail.querySelector('summary');
    this.content = this.detail.querySelector('.content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  }

  connectedCallback() {
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }
  onClick(e) {
    e.preventDefault();
    this.detail.style.overflow = 'hidden';
    if (this.isClosing || !this.detail.open) {
      this.open();
    } else if (this.isExpanding || this.detail.open) {
      this.shrink();
    }
  }



  shrink() {
    this.isClosing = true;
    const startHeight = `${this.detail.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.detail.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.detail.style.height = `${this.detail.offsetHeight}px`;
    this.detail.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.detail.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.detail.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  onAnimationFinish(open) {
    this.detail.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.detail.style.height = this.detail.style.overflow = '';
  }
}
customElements.define('custom-accordion', CustomAccordion);

class FooterAccordion extends CustomAccordion {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.openDetailsOnTablet();
    window.addEventListener('resize', () => this.openDetailsOnTablet())
  }

  openDetailsOnTablet() {
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    this.detail.open = mediaQuery.matches;
  }
}

customElements.define('footer-accordion', FooterAccordion);


class InteractiveMediaAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const closeIcons = this.querySelectorAll('[data-close]');
    closeIcons.forEach((closeIcon) => {
      closeIcon.addEventListener('click', (event) => {
        event.preventDefault();
        this.querySelector('details').removeAttribute('open');
      })
    })
  }
}

customElements.define('interactive-media-accordion', InteractiveMediaAccordion);